import { Card, Divider, Link, Text, Flex } from "@gravity-ui/uikit";
import { appConfig } from "src/config";

import { LanguagesBlock } from "../LanguagesBlock/LanguagesBlock.tsx";
import { ThemeBlock } from "../ThemeBlock/ThemeBlock.tsx";
import { FooterContact, FooterLink, LegalBlock } from "./components";
import { CURRENT_YEAR, SOCIAL_LINKS } from "./Footer.constants";
import css from "./Footer.module.scss";
import { useFooterData } from "./hooks/useFooterData.tsx";

export const Footer = () => {
  const { contacts, links, titles } = useFooterData();

  return (
    <div className={css.footerWrapper}>
      <footer className={css.footer}>
        <div className={css.bottomRow}>
          <div className={css.linksBlock}>
            <Text variant="body-2" className={css.columnTitle}>
              {titles.navigation}
            </Text>
            <div className={css.linkList}>
              {links.map((link) => (
                <FooterLink key={link.path} item={link} />
              ))}
            </div>
          </div>

          <div className={css.contactsBlock}>
            <Text variant="body-2" className={css.columnTitle}>
              {titles.contacts}
            </Text>
            <div className={css.contactsList}>
              {contacts.map((item) => (
                <FooterContact key={item.href} item={item} />
              ))}
            </div>
          </div>

          <div className={css.legalColumn}>
            <Text variant="body-2" className={css.columnTitle}>
              {titles.privacy}
            </Text>
            <LegalBlock />
          </div>

          <div className={css.socialBlock}>
            <Text variant="body-2" className={css.columnTitle}>
              {titles.social}
            </Text>
            <div className={css.socialList}>
              {SOCIAL_LINKS.map((item) => (
                <Link
                  key={item.id}
                  href={item.href}
                  target="_blank"
                  rel="noopener"
                  className={css.socialLink}
                >
                  <Card
                    view="clear"
                    type="container"
                    className={css.socialCard}
                  >
                    <item.Icon />
                  </Card>
                </Link>
              ))}
            </div>
          </div>
        </div>

        <Divider className={css.divider} />

        <Flex alignItems={"center"} justifyContent={"space-between"} gap={4}>
          <Text
            variant="subheader-1"
            color="secondary"
            className={css.footerCopyright}
            as="div"
          >
            © 2023-{CURRENT_YEAR}. {appConfig.displayName} Dev.
          </Text>

          <Flex gap={4}>
            <ThemeBlock size="m" />
            <LanguagesBlock size="m" />
          </Flex>
        </Flex>
      </footer>
    </div>
  );
};
